import React from 'react';
import { PageHero } from '../components/PageHero';
import { site } from '../data/site';
const sections = [{
  title: 'Your privacy matters',
  body: 'Your privacy is important to us. This notice explains how information you provide to Total Home Improvement is used.'
}, {
  title: 'How information is used',
  body: 'Information you provide is used to better service you. It helps us respond to your request and complete the work you have asked us to do.'
}, {
  title: 'Sharing with outside parties',
  body: 'Your information is not shared with outside parties except as necessary to complete your order or service.'
}, {
  title: 'E-mail addresses',
  body: 'Return e-mail addresses are used to answer the e-mail we receive. They are not shared for any other purpose.'
}, {
  title: 'Personally identifiable information',
  body: 'We do not use or share personally identifiable information in ways unrelated to the reason it was provided without first giving you the opportunity to opt out or otherwise prohibit that use.'
}, {
  title: 'Thank you',
  body: 'Thank you for your business.'
}];
export function Privacy() {
  return <>
      <PageHero eyebrow="Legal" title="Privacy Policy" crumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'Privacy Policy'
    }]} data-id="element-412" data-mp="q2m1v2o71y82" />
      <section className="mx-auto max-w-3xl px-6 py-14 md:py-20" data-id="element-413" data-mp="uvnlfnzcilxz">
        <div className="space-y-8" data-id="element-414" data-mp="zrvvwo2llqyt">
          {sections.map(s => <div key={s.title} data-id="element-415" data-mp="14r8prsrvzyaw">
              <h2 className="border-b-2 border-safety pb-2 font-display text-2xl font-bold uppercase tracking-tight text-ink" data-id="element-416" data-mp="14q73st9c1ree">
                {s.title}
              </h2>
              <p className="mt-3 text-base leading-relaxed text-ink-600" data-id="element-417" data-mp="1dsot5gkab05m">
                {s.body}
              </p>
            </div>)}
        </div>

        <div className="mt-12 rounded-sm border border-steel-200 bg-white p-6" data-id="element-418" data-mp="3an33jlyoez2y">
          <h2 className="font-display text-xl font-semibold uppercase tracking-tight text-ink" data-id="element-419" data-mp="3fk1ujvn1mpwx">
            Questions about this policy
          </h2>
          <p className="mt-2 text-sm leading-relaxed text-steel-500" data-id="element-420" data-mp="hqruta6nb24t">
            Contact us at{' '}
            <a href={site.emailHref} className="break-all font-semibold text-safety hover:underline" data-id="element-421" data-mp="vq9kdrrrmjf8">
              {site.email}
            </a>{' '}
            or{' '}
            <a href={site.estimatePhone.href} className="font-semibold text-safety hover:underline" data-id="element-422" data-mp="15n5lhcfc439r">
              {site.estimatePhone.display}
            </a>
            . Mail: {site.address.company}, {site.address.line1},{' '}
            {site.address.city}, {site.address.state} {site.address.zip}.
          </p>
        </div>
      </section>
    </>;
}